<ng-container>
	<!-- Title -->
	<div mat-dialog-title class="mat-dialog-header">
		<h2 class="dialog-title">Add Protocol Filter To Project</h2>
	</div>
	<div mat-dialog-content>
		<!-- Form -->
		<form #orgMemberForm="ngForm" class="pv-form single-column" [formGroup]="formGroup" (ngSubmit)="attempt()">
			<!-- Protocol -->
			<mat-form-field *ngIf="protocolOptions$ | async as customProtocols; else customProtocolLoader">
				<mat-label>Protocol</mat-label>
				<mat-select formControlName="protocolKey">
					<mat-select-trigger>
						<ng-container *ngIf="selectedProtocol">
							<span>{{ selectedProtocol.title }}</span>
						</ng-container>
					</mat-select-trigger>

					<mat-option *ngFor="let customProtocol of customProtocols" [value]="customProtocol.id" (click)="selectedProtocol = customProtocol">
						<mat-icon *ngIf="customProtocol.favourite">star</mat-icon>
						<span>{{ customProtocol.title }}</span>
					</mat-option>
				</mat-select>
				<mat-error>Select a Protocol</mat-error>
			</mat-form-field>
			<ng-template #customProtocolLoader>
				<mat-progress-bar mode="indeterminate"></mat-progress-bar>
			</ng-template>
		</form>
	</div>
	<!-- Actions -->
	<pv-form-actions mat-dialog-actions [form]="orgMemberForm" (cancel)="cancel()">
	</pv-form-actions>
</ng-container>
